import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Tooltip, OverlayTrigger, Modal, Button } from 'react-bootstrap';
import { Checkbox } from '@mui/material';
import { searchTests } from '../../../../services/clinicPortalServices/testService';
import { easyUpdateFacility } from '../../../../services/clinicPortalServices/facilityServices';
import { ModalStyled } from '../../../../theme/customizedStyleComponents';

import RecordDetails from '../../../common/RecordDetails';
export default class EditBtnCellRenderer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            showPanel: false,
            facilityId: props.data._id,
            tests: [],
            patient_test_result_management_info: props.data.patient_test_result_management_info
                ? props.data.patient_test_result_management_info
                : {}
        };
        let testIds = props.data.testIds.map((test) => {
            return test._id;
        });
        searchTests({ _id: testIds }).then((res) => {
            this.setState({ tests: res.data });
        });
    }

    renderPanel() {
        const d = this.props.data;
        const ps = {
            overlay: { position:'fixed',top:0,left:0,right:0,bottom:0,background:'rgba(0,0,0,0.3)',zIndex:1040 },
            panel: { position:'fixed',top:0,right:0,width:'420px',height:'100vh',background:'#fff',boxShadow:'-4px 0 20px rgba(0,0,0,0.15)',zIndex:1041,display:'flex',flexDirection:'column',overflowY:'auto' },
            header: { padding:'16px 20px',borderBottom:'1px solid #e0e0e0',display:'flex',alignItems:'center',justifyContent:'space-between',background:'#f8f9fa' },
            title: { margin:0,fontSize:'16px',fontWeight:600,color:'#333' },
            body: { padding:'20px',flex:1 },
            section: { marginBottom:'20px' },
            sectionTitle: { fontSize:'11px',fontWeight:700,color:'#888',letterSpacing:'0.08em',textTransform:'uppercase',marginBottom:'10px',paddingBottom:'6px',borderBottom:'1px solid #eee' },
            dl: { display:'grid',gridTemplateColumns:'140px 1fr',rowGap:'8px',margin:0 },
            dt: { fontSize:'13px',color:'#555',fontWeight:600,paddingRight:'8px' },
            dd: { fontSize:'13px',color:'#222',margin:0 },
            editBtn: { background:'#0066cc',color:'#fff',border:'none',borderRadius:'4px',padding:'6px 14px',fontSize:'13px',cursor:'pointer',marginRight:'8px' },
            closeBtn: { background:'transparent',border:'none',fontSize:'18px',cursor:'pointer',color:'#666' }
        };
        const testCount = (d.testIds && d.testIds.length) || 0;
        const managedCount = d.patient_test_result_management_info ? Object.keys(d.patient_test_result_management_info).length : 0;
        return ReactDOM.createPortal(
            <>
                <div style={ps.overlay} onClick={() => this.setState({ showPanel: false })} />
                <div style={ps.panel}>
                    <div style={ps.header}>
                        <h5 style={ps.title}>Test Result Management</h5>
                        <div>
                            <button style={ps.editBtn} onClick={() => { this.setState({ showPanel: false }); this.handleShow(); }}><i className="fas fa-pen" style={{ marginRight:5 }}></i>Edit</button>
                            <button style={ps.closeBtn} onClick={() => this.setState({ showPanel: false })}><i className="fas fa-times"></i></button>
                        </div>
                    </div>
                    <div style={ps.body}>
                        <div style={ps.section}>
                            <div style={ps.sectionTitle}>Facility</div>
                            <dl style={ps.dl}>
                                <dt style={ps.dt}>Name</dt><dd style={ps.dd}>{d.name || '—'}</dd>
                                <dt style={ps.dt}>Tests Assigned</dt><dd style={ps.dd}>{testCount}</dd>
                                <dt style={ps.dt}>Tests Restricted</dt><dd style={ps.dd}>{managedCount > 0 ? managedCount : 'None'}</dd>
                            </dl>
                        </div>
                        {testCount > 0 && (
                            <div style={ps.section}>
                                <div style={ps.sectionTitle}>Assigned Tests</div>
                                <div style={{ fontSize:'13px',color:'#222' }}>
                                    {d.testIds.map((t, i) => {
                                        const restricted = d.patient_test_result_management_info && d.patient_test_result_management_info[t._id];
                                        return (
                                            <div key={i} style={{ padding:'4px 0',borderBottom:'1px solid #f0f0f0',display:'flex',justifyContent:'space-between' }}>
                                                <span>{t.name || t._id}</span>
                                                {restricted && <span style={{ color:'#dc3545',fontSize:'11px',fontWeight:600 }}>RESTRICTED</span>}
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        )}
                    
                        <RecordDetails data={d} exclude={['name', 'patient_test_result_management_info', 'testIds', 'results', 'password', 'token', 'resetPasswordToken', 'refreshToken']} />
                    </div>
                </div>
            </>,
            document.body
        );
    }

    renderTooltipEdit = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            Edit
        </Tooltip>
    );

    handleShow = () => {
        this.setState({ show: true });
    };

    handleClose = () => {
        this.setState({ show: false });
    };

    handleCheck = (type, testId, subTestId = null, is_panel = null) => {
        let patient_test_result_management_info = this.state.patient_test_result_management_info;
        if (type === 'test') {
            if (patient_test_result_management_info && patient_test_result_management_info[testId]) {
                delete patient_test_result_management_info[testId];
            } else {
                patient_test_result_management_info[testId] = is_panel ? [] : 'single';
            }
        } else {
            if (
                patient_test_result_management_info &&
                patient_test_result_management_info[testId] &&
                patient_test_result_management_info[testId].includes(subTestId)
            ) {
                patient_test_result_management_info[testId] = patient_test_result_management_info[testId].filter(
                    (item) => item !== subTestId
                );
            } else {
                patient_test_result_management_info[testId].push(subTestId);
            }
        }
        this.setState({ patient_test_result_management_info: patient_test_result_management_info });
    };

    saveChanges = () => {
        easyUpdateFacility({
            _id: this.state.facilityId,
            patient_test_result_management_info: this.state.patient_test_result_management_info
        }).then((res) => {
            this.handleClose();
            this.props.context.componentParent.loadGridData();
        });
    };

    render() {
        return (
            <div style={{ textAlign: 'left' }}>
                <OverlayTrigger placement="top" delay={{ show: 50, hide: 100 }} overlay={<Tooltip id="button-tooltip">View Test Management</Tooltip>}>
                    <button onClick={() => this.setState({ showPanel: true })} className="edit-order-btn">
                        <i className="fas fa-eye"></i>
                    </button>
                </OverlayTrigger>
                {this.state.showPanel && this.renderPanel()}
                <OverlayTrigger placement="top" delay={{ show: 50, hide: 100 }} overlay={this.renderTooltipEdit}>
                    <button onClick={this.handleShow} className="edit-order-btn">
                        <i className="fas fa-pen"></i>
                    </button>
                </OverlayTrigger>
                <ModalStyled
                    size="xl"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    show={this.state.show}
                    onHide={this.handleClose}
                    backdrop="static"
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Update Facility Test Result Management</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div>
                            <div className="row form-row">
                                <div className="col-12 form-group">
                                    <label>Name</label>
                                    <input className="form-control" value={this.props.data.name} disabled />
                                </div>
                                <div className="col-12 form-group">
                                    By selecting any of the following, for those tests the patient will need to contact
                                    you directly for the result and it will not be available to them in the BlueLot
                                    patient portal.
                                    <br />
                                    <br />
                                    <label>Don't allow patients to see results for:</label>
                                    <br />
                                    {this.state.tests.map((test, testIndex) => {
                                        let testChecked =
                                            this.state.patient_test_result_management_info &&
                                            this.state.patient_test_result_management_info[test._id]
                                                ? true
                                                : false;
                                        let subTestDomForBundle = [];
                                        if (test.is_panel && test.testIds && test.testIds.length && testChecked) {
                                            subTestDomForBundle.push(
                                                <div style={{ padding: '0px 20px' }} key="question">
                                                    If not showing full result PDF of panel to the patient in the portal
                                                    as you selected above, do you want to show them any of the
                                                    individual test results from within that panel?
                                                </div>
                                            );
                                            test.testIds.map((subTest) => {
                                                let subTestChecked =
                                                    this.state.patient_test_result_management_info &&
                                                    this.state.patient_test_result_management_info[test._id] &&
                                                    this.state.patient_test_result_management_info[test._id].includes(
                                                        subTest._id
                                                    )
                                                        ? true
                                                        : false;
                                                subTestDomForBundle.push(
                                                    <div style={{ padding: '0px 10px' }} key={subTest._id}>
                                                        <Checkbox
                                                            checked={subTestChecked}
                                                            onClick={() =>
                                                                this.handleCheck('sub_test', test._id, subTest._id)
                                                            }
                                                        />{' '}
                                                        {subTest.name}
                                                    </div>
                                                );
                                                return null;
                                            });
                                        }
                                        return (
                                            <div key={testIndex}>
                                                <Checkbox
                                                    checked={testChecked}
                                                    onClick={() =>
                                                        this.handleCheck('test', test._id, null, test.is_panel)
                                                    }
                                                />{' '}
                                                {test.name}
                                                <br />
                                                {subTestDomForBundle}
                                                <hr style={{ margin: '0px', borderTop: '2px solid rgba(0,0,0,.1)' }} />
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12 modal-button-col">
                                    <Button
                                        style={{ float: 'right', marginLeft: '10px' }}
                                        variant="primary"
                                        onClick={this.saveChanges}
                                    >
                                        Save Changes
                                    </Button>
                                    <Button style={{ float: 'right' }} variant="secondary" onClick={this.handleClose}>
                                        Close
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                </ModalStyled>
            </div>
        );
    }
}
